import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import Services from './Services';
import SEO from './SEO';

export const DienstleistungenPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO page="dienstleistungen" />
      <Header />
      <main className="flex-1 pt-20">
        <Services />
      </main>
      <Footer />
    </div>
  );
};

export default DienstleistungenPage;
